import $ from "jquery";
import { Swiper } from "swiper";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/scss";
import "swiper/scss/navigation";
import gsap from "gsap";

$(".js-fade-slider-anim").each(function () {
  const prevButton = this.querySelector(".slider-navigation .slider--prev");
  const nextButton = this.querySelector(".slider-navigation .slider--next");

  const enableAutoplay = $(this).hasClass("enable-autoplay");
  const enableLoop = $(this).hasClass("enable-loop");

  const swiper = new Swiper(this.querySelector(".swiper"), {
    modules: [Autoplay, Navigation],
    slidesPerView: 1,
    autoplay: enableAutoplay,
    loop: enableLoop,
    speed: 1000,
    navigation: {
      prevEl: prevButton,
      nextEl: nextButton,
    },
    on: {
      slideChange: function () {
        if (window.innerWidth <= 991) {
          // Do nothing on mobile
          return;
        }
        // Get the currently active slide
        const currentSlide = $(swiper.slides[swiper.activeIndex]);

        // Get the previous and next slides
        const prevSlide = $(swiper.slides[swiper.previousIndex]);
        const nextSlide = $(swiper.slides[swiper.activeIndex + 1]);

        // Animate only the images within the current, previous, and next slides
        gsap.fromTo(
          currentSlide.find(".image-block__image--large"),
          { x: 700 },
          { x: 0, duration: 1 },
        );

        gsap.fromTo(
          currentSlide.find(".image-block__image--small"),
          { x: 50 },
          { x: "-8.698vw", duration: 1 },
        );
      },
    },
  });
});
